import React from "react";

interface DetailSectionProps {
  title: string;
  children: React.ReactNode;
  actions?: React.ReactNode;
  bgColor?: string;
}

/** Titled card wrapper, replacing the repeated `bg-gray-50 p-4 rounded-lg` blocks. */
export const DetailSection: React.FC<DetailSectionProps> = ({
  title,
  children,
  actions,
  bgColor = "bg-gray-50",
}) => (
  <div className={`${bgColor} p-4 rounded-lg`}>
    <div className="flex items-center justify-between mb-4">
      <h3 className="text-base font-semibold text-gray-900">{title}</h3>
      {actions}
    </div>
    {children}
  </div>
);
